import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'datetimeCountdown',
})
export class DateCountdownPipe implements PipeTransform {
  transform(value: number): string {
    const minutes: number = Math.floor(value / 60000); // Convert to minutes
    const seconds: number = Math.floor((value % 60000) / 1000); // Get remaining seconds
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

    return `${formattedMinutes}:${formattedSeconds}`;
  }
}
